import type {IEvent} from "../../api/dto/IEvent";

export const filterFunc = (filterEvents: IEvent[]) => filterEvents.filter((filter) => new Date(filter.end_time * 1000).getTime() > Date.now());

export const parseAndFilterFunk = (res: string[], past?: boolean) =>
  res.map((el) => parseFunk(el))
    .filter((filter) => (past ? true : new Date(filter.end_time * 1000).getTime() > Date.now()));

export const parseFunk = (string: string): IEvent => {
  const parseEl = JSON.parse(string);
  return {
    ...parseEl,
    sport: JSON.parse(parseEl?.sport || "null"),
    league: JSON.parse(parseEl?.league || "null"),
    location: JSON.parse(parseEl?.location || "null"),
    participantHome: JSON.parse(parseEl?.participantHome || "null"),
    participantAway: JSON.parse(parseEl?.participantAway || "null"),
    spm_odds: JSON.parse(parseEl?.spm_odds || "null"),
  };
};
